export const listMutations = <const>{
	TABULKOVA_POZICE_SELECT_MAPPER: 'TABULKOVA_POZICE_SELECT_MAPPER',
	NAKLADOVE_STREDISKO_SELECT_MAPPER: 'NAKLADOVE_STREDISKO_SELECT_MAPPER',
	UPDATE_TABLE_CELL: 'UPDATE_TABLE_CELL',
	UPDATE_TABLE_COLUMN: 'UPDATE_TABLE_COLUMN',
};

export const listActions = <const>{
	UPDATE_TABLE_COLUMN: 'updateTableColumn',
	SAVE_TABLE: 'saveTable',
};
